export const getSelectedReport = (item) => {
    return  {
        type: "SELECTED_REPORT",
        payload: item
    };
};
